// import hooks
import React, { useContext, useEffect, useState } from "react";

// import context
import { DarkModeContext } from "../../context/DarkModeContext";

// import librerias
import { Button } from "react-bootstrap";

// import components
import ModalConsultasAliados from "./ModalConsultasAliados";
import TablaConsultasAliados from "./TablaConsultasAliados";
import FormularioConFirma from "./FormularioConFirma";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../utils/auth";


const ContenidoConsultasAliados = ({ aliadoVariant = false }) => {
  // context para el modo claro/oscuro
  const { darkMode } = useContext(DarkModeContext);

  // estado para controlar la apertura y cierre del modal
  const [modalShowCompleta, setModalShowCompleta] = React.useState(false);

  // Estado inicial para los datos de la tabla
  // priority-1, priority-2 y priority-11 son para mostrar en la version mobile.

  const [consultas, setConsultas] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchComandas = async () => {
      setIsLoading(true);
      setError(null);
      const token = getToken();

      if (token) {
        try {
          const response = await fetch(
            process.env.REACT_APP_API_COMANDA_POR_USUARIO,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ token }),
            }
          );

          if (!response.ok) {
            throw new Error("La respuesta de la red no fue correcta");
          }

          const data = await response.json();
          // Ordena las consultas antes de actualizar el estado
          const ordenadas = data.sort(
            (a, b) => new Date(b.fechaApertura) - new Date(a.fechaApertura)
          );
          setConsultas(ordenadas);
        } catch (error) {
          setError(error.message);
          console.error("Hubo un error:", error);
        }
      } else {
        setError("No se encontró token en sessionStorage.");
      }
      setIsLoading(false);
    };

    fetchComandas();
  }, []);

  return (
    <div className={aliadoVariant ? "aliado-consultas-history" : "container"}>
      <div className={aliadoVariant ? "aliado-consultas-history-head" : "d-flex justify-content-end"}>
        {aliadoVariant && <h2>Historial de consultas</h2>}
        <Button
          className={
            darkMode
              ? "centrado border-0 btn-nueva-consulta"
              : "centrado  border-0 btn-nueva-consulta"
          }
          onClick={() => setModalShowCompleta(true)}
        >
          <FontAwesomeIcon className="me-2" icon={faPlus} />
          <span>{aliadoVariant ? "Nueva consulta" : "Nueva"}</span>
        </Button>
        <ModalConsultasAliados
          show={modalShowCompleta}
          onHide={() => setModalShowCompleta(false)}
          aliadoVariant={aliadoVariant}
        />
      </div>
      <div className={aliadoVariant ? "aliado-consultas-list" : "py-2"}>
        <TablaConsultasAliados
          consultas={consultas}
          isLoading={isLoading}
          aliadoVariant={aliadoVariant}
        />
      </div>
    </div>
  );
};

export default ContenidoConsultasAliados;
